import { isNullOrUndefined } from '../general-helpers';
import { QueryConstants } from './query-constants';

export const reloadToBasePage = () => {
    window.location = window.location.origin;
};

export const redirectTo = (address, preserveQuery = false) => {
    if (isNullOrUndefined(address)) {
        return;
    }

    const isRelative = !address.startsWith('http');

    // Create a URL object for the target URL
    let targetUrl;
    if (isRelative) {
        // If the URL is relative, create an absolute URL
        const currentUrl = new URL(window.location.href);
        targetUrl = new URL(address, currentUrl.origin);
    } else {
        // If the URL is absolute, use it directly
        targetUrl = new URL(address);
    }

    if (preserveQuery) {
        // Get the current URL's query parameters
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => {
            targetUrl.searchParams.append(key, value);
        });
    }

    // Perform the redirect
    window.location.href = targetUrl.toString();
};

export const reloadPage = () => {
    window.location.reload();
};

export const reloadPageWithoutQueryParams = () => {
    window.location.href = window.location.pathname;
};

export const reloadToBasePageWithSignInPopup = () => {
    window.location = `${window.location.origin}?${QueryConstants.SHOW_POPUP}=api/sitecore/Account/SignIn`;
};

export const reloadPageWithComponentToRender = (componentToRender) => {
    window.location = `${window.location.origin}/account/profile?componentToRender=${componentToRender}`;
};

export const getPageUrlWithoutQueryParams = () => {
    return window.location.href.split('?')[0];
};

export const getPageUrl = () => {
    return window.location.href;
};
